import { WhileWorkflowNode } from '@blaze-shared/workflow-domain';

import {
  ConnectorProvider,
  WorkflowNodeConnectorProvider,
} from '../../registry/connector-provider.registry';

@WorkflowNodeConnectorProvider('While')
export class WhileConnectorProvider extends ConnectorProvider<WhileWorkflowNode> {}
